import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Button, Modal, Row, Col, FormGroup, FormControl } from 'react-bootstrap'
import ColorPicker from '../ColorPicker'
import EventTypeSelector from '../EventTypeSelector'
import CopyableTextBlock from '../CopyableTextBlock'
import stringifyProps from './stringifyProps'

export default class AppointmentScheduler extends Component {
  state = {
    userId: this.props.userAppointmentCalendars[0].userId,
    userAppointmentCalendarId: "",
    showModal: false,
    style: "embed",
    maxWidth: "",
    iframe: false
  }

  static propTypes = {
    type: PropTypes.string.isRequired,
    host: PropTypes.string.isRequired,
    usersWithAppointmentCalendars: PropTypes.array.isRequired,
    userAppointmentCalendars: PropTypes.array.isRequired,
    apiKey: PropTypes.string.isRequired
  }

  showModal = () => {
    this.setState({showModal: true})
  }

  hideModal = () => {
    this.setState({showModal: false})
  }

  get html() {
    const { host, apiKey } = this.props
    const { style, userAppointmentCalendarId, userId, maxWidth, iframe} = this.state

    const baseProps = { apiKey, userAppointmentCalendarId, userId, iframe, host: `https://${host}` }
    let dataProps = {}
    const combinedProps = {...baseProps, ...dataProps}

    if(style === "basicLink") {
      let url = appointmentUrl({ host, userId, userAppointmentCalendarId })
      if(Object.keys(dataProps).length > 0) {
        url = `${url}?props=${encodeURIComponent(stringifyProps(dataProps))}`
      }
      return url
    }
    else if(style === "embed" && !iframe) {
      return `<script src="https://${host}/api/checkcherry_widgets" type="text/javascript" charset="utf-8"></script><div class="checkcherry__widget__appointment-scheduler" data-props='${stringifyProps(combinedProps)}'></div>`
    }
    else if(style === "embed" && iframe) {
      return `<iframe class="checkcherry-autoresize-frame" src="${appointmentUrl({ host, userId, userAppointmentCalendarId })}?iframe=true&props=${encodeURIComponent(stringifyProps(dataProps))}" style="margin: 0; padding: 0; border: none; max-width: ${maxWidth || "500px"}; width: 100%; height: 400px" scrolling="auto" allowtransparency="true"></iframe><script src="https://${host}/api/checkcherry_widgets/iframe" type="text/javascript" charset="utf-8"></script>`
    }
    else {
      return ""
    }
  }

  render() {
    const { type, userAppointmentCalendars, usersWithAppointmentCalendars } = this.props
    const { showModal, style, userId, userAppointmentCalendarId, maxWidth, iframe} = this.state

    const calendarsForUser = userAppointmentCalendars.filter(userAppointmentCalendar => userAppointmentCalendar.userId === userId)
    return (
      <div>
        <div className="btn-group">
          <Button onClick={this.showModal} variant="primary">
            <i className="fa fa-code" />
            { " " }
            Get Embed Code
          </Button>
        </div>
        <Modal show={showModal} onHide={this.hideModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Availability Scheduler Widget</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={7}>
                <h3>Customize</h3>
                <FormGroup className="mb-2">
                  <Form.Label>Choose Style</Form.Label>
                  <Form.Check
                    type="radio"
                    name="style"
                    checked={style === "basicLink"}
                    onChange={() => this.setState({style: "basicLink"})}
                    label="Link Only"
                    id="contact-form-style-link"
                  />
                  <Form.Check
                    type="radio"
                    name="style"
                    checked={style === "embed"}
                    onChange={() => this.setState({style: "embed"})}
                    label="Embed on my site"
                    id="contact-form-style-embed"
                  />
                </FormGroup>
                <FormGroup className="mb-2">
                  <Form.Label>Choose Staff</Form.Label>
                  { usersWithAppointmentCalendars.map(user =>
                    <Form.Check
                      type="radio"
                      key={user.userId}
                      name="user"
                      checked={user.userId === userId}
                      onChange={() => this.setState({ userId: user.userId })}
                      label={user.fullName}
                      id={`user-${user.userId}`}
                    />
                  )}
                  <div>
                    Note: Only staff with the "Enhanced Scheduling Role" will show up here.  Visit the 
                    { " " }
                    <a href="/admin/users">user account page</a>
                    { " " }
                    to add this role to a user.
                  </div>
                </FormGroup>
                { calendarsForUser.length > 1 &&
                  <FormGroup className="mb-2">
                    <Form.Label>Choose Calendar</Form.Label>
                    <Form.Check
                      type="radio"
                      name="userAppointmentCalendar"
                      checked={ !userAppointmentCalendarId }
                      onChange={() => this.setState({ userAppointmentCalendarId: "" })}
                      label="All Calendars for Staff"
                      id={`user-appointment-calendar-all`}
                    />
                    { userAppointmentCalendars.filter(userAppointmentCalendar => userAppointmentCalendar.userId === userId).map(userAppointmentCalendar =>
                    <Form.Check
                      type="radio"
                      key={userAppointmentCalendar.id}
                      name="userAppointmentCalendar"
                      checked={userAppointmentCalendar.id === userAppointmentCalendarId }
                      onChange={() => this.setState({ userAppointmentCalendarId: userAppointmentCalendar.id })}
                      label={userAppointmentCalendar.title}
                      id={`user-appointment-calendar-${userAppointmentCalendar.id}`}
                    />
                    )}
                  </FormGroup>
                }
                { style === "embed" &&
                <FormGroup className="mb-2">
                  <Form.Label>Enable Compatibility Mode?</Form.Label>
                  <Form.Check
                    type="radio"
                    name="iframe"
                    checked={iframe === true}
                    onChange={() => this.setState({iframe: true})}
                    label="Yes"
                    id="user-appointment-calendar-iframe-yes"
                  />
                  <Form.Check
                    type="radio"
                    name="iframe"
                    checked={iframe === false}
                    onChange={() => this.setState({iframe: false})}
                    label="No"
                    id="user-appointment-calendar-iframe-no"
                  />
                  <Form.Text muted>Compatibility mode embeds widget within an iFrame for greater compatibility with some website builders</Form.Text>
                </FormGroup>
                }
              </Col>
              <Col sm={5}>
                <h3>HTML</h3>

                <p>Copy and paste the HTML below into your website to add your contact form</p>

                <FormGroup>
                  <CopyableTextBlock value={this.html} />
                </FormGroup>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.hideModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

function appointmentUrl({ host, userId, userAppointmentCalendarId }) {
  if(userId && userAppointmentCalendarId) {
    return `https://${host}/schedule/${userId}/${userAppointmentCalendarId}`
  }
  else if(userId) {
    return `https://${host}/schedule/${userId}`
  }
  else {
    return ""
  }
}

